// DEVELOPMENT

// export const baseURL = "http://doodlebluelive.com";
// export const doctorBaseUrl = `${baseURL}:2055/api/v1/doctor`;
// export const createPrescription = `${baseURL}:2057/api/v1`;
// export const appoinments = `${baseURL}:2056/api/v1`;
// export const userBaseUrl = `${baseURL}:2055/api/v1/user`;

// PRE PRODUCTION

// test add
// export const baseURL = "https://apidev.meradoc.com";

// export const msVideoCallMainUrl = "meradoc-preprod-videoconf-2056";
// export const baseURL = "http://localhost:8000";

// // export const baseURL = "https://meradoc-preprod-segregation";
// export const baseURL = "https://meradoc-preprod-segregation";
// export const baseURL = "https://meradoc-preprod-segregation";

// export const doctorBaseUrl = `${baseURL}/user/api/v1/doctor`;
// export const createPrescription = `${baseURL}/prescription/api/v1`;
// export const appoinments = `${baseURL}/appointment/api/v1`;
// export const userBaseUrl = `${baseURL}/user/api/v1/user`;

// PRODUCTION

// v1.24 base url
// export const baseURL = "https://api-1-24.meradoc.com";
export const baseURL = "https://api.meradoc.com";
export const doctorBaseUrl = `${baseURL}/gouser/api/v1/doctor`;
export const createPrescription = `${baseURL}/goprescription/api/v1`;
export const pharmacy = `${baseURL}/gopharmacy/api/v1`;
export const appoinments = `${baseURL}/goappointment/api/v1`;
export const userBaseUrl = `${baseURL}/gouser/api/v1/user`;
export const msVideoCallMainUrl = "meradoc-prod-videoconf-1518";

export const endpoints = {
  auth: {
    SEND_OTP: `${doctorBaseUrl}/sendOTP`,
    VERIFY_OTP: `${doctorBaseUrl}/verifyOTP`,
    CREATE_PASSWORD: `${doctorBaseUrl}/createPassword`,
    LOGIN: `${doctorBaseUrl}/signIn`,
    RESET_PASSWORD: `${doctorBaseUrl}/resetPassword`,
    FORGET_PASSWORD: `${doctorBaseUrl}/forgetPassword `,
    LOGOUT: `${userBaseUrl}/logout`,
  },
  availability: {
    CREATE_AVAILABILITY: `${appoinments}/slots/create`,
    GET_ONLINE: `${appoinments}/slots/list`,
    GET_ONLINE_UPDATE: `${appoinments}/slots/update`,
    DELETE_ONLINE: `${appoinments}/slots/delete`,
  },
  emergency: {
    GET_EMERGENCY: `${appoinments}/slots/emergency/get`,
    QUERY_EMERGENCY: `${appoinments}/slots/emergency/query`,
    CREATE_EMERGENCY: `${appoinments}/slots/emergency/create`, //prod
  },
  prescription: {
    CREATE_PRESCRIPTION: `${createPrescription}/prescription/prescription/create`,
    UPDATE_PATCH: `${createPrescription}/prescription/prescription`,
    ADD_NEW_DRUG: `${createPrescription}/drug/drug`,
    GET_ADDED_DRUGS: `${createPrescription}/drug/drugs`,
    ADD_MEDICINE: `${createPrescription}/medicine/medicine`,
    ADD_MEDICINE_MULTI: `${createPrescription}/medicine/medicine/many`,
    GET_ALL_MEDICINE: `${createPrescription}/medicine/medicines`,
    GET_PRESCRIPTION_ID: `${createPrescription}/prescription/prescription/get`,
    GET_ALL_PRESCRIPTION: `${createPrescription}/prescription/prescriptionData`,
    UPLOAD_IMAGE: `${createPrescription}/prescription/upload`,
    UPLOAD_PROFILE_IMAGE: `${createPrescription}/prescription/upload/image`,
    GET_DOCTOR_MEDICINE_TYPE: `${createPrescription}/drug/drugs/types`,
    DELETE_MEDICINE: `${createPrescription}/medicine/medicines`,
    BULK_REPORT_UPLOAD: `${createPrescription}/document/document/bulk`,
    GET_DRUG_SUBSTITUTE: `${createPrescription}/drug/getDrugSubstitute`,
    GET_MEDICINE_BY_ID: `${createPrescription}/drug/drug`,
    GET_LAB_TEST_PHARMEASY: `${createPrescription}/pharmacy/pharmeasy/labTest`,
    GET_LAB_TEST_PHARMEASY_BYID: `${createPrescription}/pharmacy/pharmeasy/testByIds`
    
  },
  appointment: {
    GET_ALL_APPOINTMENT: `${appoinments}/appointment/appointments`,
    GET_SINGLE_APPOINTMENT: `${appoinments}/appointment/appointment`,
    CANCEL_APPOINTMENT: `${appoinments}/appointment/appointment-cancel`,
    UPDATE_APPOINTMENT: `${appoinments}/appointment/appointment-update`,
    GET_APPOINTMENT_SETTINGS: `${appoinments}/appointment/setting/get`,
    UPDATE_APPOINTMENT_SETTINGS: `${appoinments}/appointment/setting/update`,
    GET_ALL_SPECIALITY: `${appoinments}/specialty/list`,
    GET_GP_SLOTS: `${appoinments}/slots/available/general`,
    GET_GP_DOCSLOT: `${doctorBaseUrl}/approvedDoctors`,
    GET_SP_SLOTS: `${appoinments}/slots/available/specialist`,
    SUBMIT_PRESCRIPTION: `${appoinments}/appointment/getPrescriptionData`,
    CONNECT_VOICE_CALL: `${appoinments}/appointment/ozonetel/connectCall`,
    GET_CONSULTATION_BY_COND: `${appoinments}/appointment/getAppointmentByCond`,
    IS_APPOINTMENT_ATTENDED: `${appoinments}/appointment/markAsAttended`,
    UPDATE_MEMBER_ADDED: `${appoinments}/appointment/updateAppointment`,
    GET_SPECIALITY_LIST: `${appoinments}/specialty/list`,
    CREATE_APPOINTMENT: `${appoinments}/appointment/appointment-create`,
    CLOSE_CONSULTATION_APPOINTMENT: `${appoinments}/appointment/close/consultation`,
    CLOSE_CALL_APPOINTMENT: `${appoinments}/appointment/close/call`,
    GET_DOCTOR_NEXT_AVAILABLE: `${appoinments}/slots/next/available`,
    GET_GP_SLOTS_FOLLOW: `${appoinments}/slots/available/general/follow`,
    GET_GENERAL_SLOTS: `${appoinments}/slots/getGeneralSlots`,
    GET_VOICE_CALL: `${appoinments}/appointment/logs/voice/list`,
    GET_VOICE_CALL_BY_ID: `${appoinments}/appointment/logs/voice`,
    GET_VIDEO_CALL: `${appoinments}/appointment/logs/video/list`,
    GET_VIDEO_CALL_BY_ID: `${appoinments}/appointment/logs/video`,

    GET_LAB_RADIO_TESTNAME: `${appoinments}/appointment/labRadiologyData`,

    GET_DOCTORS_NOTE: `${appoinments}/appointment/patientDoctors_Notes`,
    UPDATE_DOCT_NOTE: `${appoinments}/appointment/updateDoctorsNote`

  },
  profile: {
    APPROVE_TEARMANDCONDITION: `${doctorBaseUrl}/isTermsAndContion`,
    CREATE_APPOINTMENT_SETTINGS: `${appoinments}/appointment/setting/create`,
    CREATE_PAYMENT: `${doctorBaseUrl}/addDoctorPaymentDetails`,
    GET_PERSONAL_PROFILE: `${doctorBaseUrl}/getPersonalDetails`,
    GET_ADDRESS_DETAIL: `${doctorBaseUrl}/getDoctorAddressDetails`,
    GET_EDUCATION_DETAILS: `${doctorBaseUrl}/getDoctorEducationDetails`,
    GET_PAYMENT_DETAILS: `${doctorBaseUrl}/getDoctorPaymentDetails`,
    ADD_BASIC_INFO: `${doctorBaseUrl}/addBasicInfo`,
    ADD_EDUCATION_DETAILS: `${doctorBaseUrl}/addDoctorEducation`,
    UPDATE_PAYMENT_DETAILS: `${doctorBaseUrl}/updateDoctorPaymentDetails`,
    UPDATE_PERSONAL_DETAILS: `${doctorBaseUrl}/updateDoctorPersonalDetails`,
    CANCEL_APPOINTMENT: `${appoinments}/appointment/appointment-cancel`,
    UPDATE_APPOINTMENT: `${appoinments}/appointment/appointment-update`,
    UPDATE_EDUCATION_DETAIL: `${doctorBaseUrl}/updateDoctorEducationDetails`,
    UPDATE_NOTIFICATION: `${doctorBaseUrl}/updateNotificationSettings`,
    CHANGE_PASSWORD: `${doctorBaseUrl}/changePassword`,
    GET_PATIENT_PROFILE: `${userBaseUrl}/userProfile`,
    GET_PATIENT_RECORDS: `${createPrescription}/document/admin/documents`, //updated
    UPDATE_MEDICAL_HISTORY: `${userBaseUrl}/createMedicalHistory`,
    GET_FAMILY_MEMBERS: `${userBaseUrl}/getFamilyMember`,
    GET_USER_STATUS: `${doctorBaseUrl}/getDoctorCompleteStatus`,
    POST_SUPPORT: `${appoinments}/appointment/support/create`,
    GET_COMMENT_SUPPORT: `${appoinments}/appointment/support/getByAppId`,
    GET_FAMILY_TREE: `${userBaseUrl}/getFamilyTree`,
    GET_FAMILY_TREE_WEB_VIEW: `${userBaseUrl}/getFamilyTreeForWebView`,
    GET_FAMILY_MEMBERS_BY_COND: `${userBaseUrl}/getFamilyMemberByCond`,
    GET_MOBILENUMBER_MEMBER: `${userBaseUrl}/patient/byMobile`,
    ADD_FAMILY_MEMBER: `${userBaseUrl}/addFamilyMember`,
    GET_FAMILY_RELATIONS: `${userBaseUrl}/family/relations`,
    HEADER_USER_DETAIL: `${userBaseUrl}/userIcon`,
    UPDATE_FAMILY_MEMBER: `${userBaseUrl}/familyMember`,
    GET_LAB_REPORTS: `${createPrescription}/document/documents`,
    GET_BY_PINCODE: `${userBaseUrl}/searchPincode`,
    EDIT_PATIENT_DETAIL: `${userBaseUrl}/editProfile`,
  },
};
